import { AdminFeedbackCycle } from '~src/hooks/api/adminFeedback/types';
import {
  ActionItems,
  FeedbackCycleActions,
  FeedbackCycleContent,
  FeedbackCycleDetails,
  FeedbackCycleItemBoxContainer,
  FeedbackCycleTitle,
  TitleContainer,
} from './FeedbackCycleItem.styled';
import { translateContent } from '~src/services/translationServices';
import StatusBox from '~src/shared/StatusBox';
import DeleteFeedbackCycleDialog from '~src/modules/companySettings/performanceManagement/FeedbackMeetingCycles/DeleteFeedbackCycleDialog/DeleteFeedbackCycleDialog';
import { useHistory } from 'react-router';
import { routes } from '~src/routingConfig';
import {useDateFormatter} from "~src/services/hooks/useDateFormatter";

const FeedbackCycleItem = ({
  name,
  cycleStartDate,
  cycleDueDate,
  meetingStartDate,
  meetingDueDate,
  active,
  id,
}: AdminFeedbackCycle) => {
  const history = useHistory();
  const dateFormatter = useDateFormatter();

  return (
    <>
      <FeedbackCycleItemBoxContainer onClick={() => {
        history.push(routes.contentScales.adminFeedbackCycle(id))
      }}>
        <FeedbackCycleDetails>
          <TitleContainer>
            <FeedbackCycleTitle>{translateContent(name)}</FeedbackCycleTitle>
            <StatusBox active={active} />
          </TitleContainer>
          <FeedbackCycleContent>{`
            ${dateFormatter(cycleStartDate)} - ${dateFormatter(cycleDueDate)}
            ,
            ${dateFormatter(meetingStartDate)} - ${dateFormatter(meetingDueDate)}
          `}</FeedbackCycleContent>
        </FeedbackCycleDetails>

        <FeedbackCycleActions>
          <ActionItems>
            <DeleteFeedbackCycleDialog feedbackCycleId={id} />
          </ActionItems>
        </FeedbackCycleActions>
      </FeedbackCycleItemBoxContainer>
    </>
  );
};

export default FeedbackCycleItem;
